var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("table", { staticClass: "table table-sm table-hover table-bordered" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.users, function (user, id, index) {
          return user.is_active
            ? _c("tr", [
                _c("td", [_vm._v(_vm._s(index + 1))]),
                _vm._v(" "),
                _c("td", [
                  _c("div", [
                    _vm.editUser
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-xs btn-info pull-left mr-2",
                            on: {
                              click: function ($event) {
                                return _vm.editUser(user)
                              },
                            },
                          },
                          [_c("i", { staticClass: "icon-fa icon-fa-eye" })]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex" },
                      [
                        _c("UserInfo", {
                          staticClass: "mr-2",
                          attrs: { user: user },
                        }),
                        _vm._v(" "),
                        _c("UserTags", {
                          attrs: {
                            tags: _vm.getDetailByAlias(user, "user_tags"),
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      _vm._l(
                        _vm.getDetailByAlias(user, "order_access"),
                        function (record) {
                          return _c(
                            "span",
                            { staticClass: "badge badge-success mr-1" },
                            [
                              _vm._v(
                                _vm._s(
                                  record.project_id === "all"
                                    ? "Все проекты"
                                    : _vm.$AllProjects[record.project_id].name
                                )
                              ),
                            ]
                          )
                        }
                      ),
                      0
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  [
                    _vm.sortedAssistance[user.id] &&
                    _vm.sortedAssistance[user.id].length
                      ? _vm._l(
                          _vm.sortedAssistance[user.id],
                          function (assist) {
                            return assist.is_active
                              ? _c(
                                  "div",
                                  [
                                    _vm.editUser
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-xs btn-info pull-left mr-2",
                                            on: {
                                              click: function ($event) {
                                                return _vm.editUser(assist)
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "icon-fa icon-fa-eye",
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("UserInfo", { attrs: { user: assist } }),
                                    _vm._v(" "),
                                    _c("UserTags", {
                                      attrs: {
                                        tags: _vm.getDetailByAlias(
                                          assist,
                                          "user_tags"
                                        ),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      _vm._l(
                                        _vm.getDetailByAlias(
                                          assist,
                                          "order_access"
                                        ),
                                        function (record) {
                                          return _c(
                                            "span",
                                            {
                                              staticClass:
                                                "badge badge-success mr-1",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  record.project_id === "all"
                                                    ? "Все проекты"
                                                    : _vm.$AllProjects[
                                                        record.project_id
                                                      ].name
                                                )
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e()
                          }
                        )
                      : _vm._e(),
                  ],
                  2
                ),
              ])
            : _vm._e()
        }),
        0
      ),
    ]),
    _vm._v(" "),
    _c("h5", [_vm._v("Помощники без привязки к менеджеру")]),
    _vm._v(" "),
    Object.keys(_vm.freeAssists).length
      ? _c("table", { staticClass: "table table-hover table-sm" }, [
          _c(
            "tbody",
            _vm._l(_vm.freeAssists, function (assist, index) {
              return _c("tr", [
                _c("td", { attrs: { width: "70px" } }, [
                  _vm._v(_vm._s(index + 1)),
                ]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "div",
                    [
                      _vm.editUser
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-xs btn-info pull-left mr-2",
                              on: {
                                click: function ($event) {
                                  return _vm.editUser(assist)
                                },
                              },
                            },
                            [_c("i", { staticClass: "icon-fa icon-fa-eye" })]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("UserInfo", { attrs: { user: assist } }),
                      _vm._v(" "),
                      _c("UserTags", {
                        attrs: {
                          tags: _vm.getDetailByAlias(assist, "user_tags"),
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        _vm._l(
                          _vm.getDetailByAlias(assist, "order_access"),
                          function (record) {
                            return _c(
                              "span",
                              { staticClass: "badge badge-success mr-1" },
                              [
                                _vm._v(
                                  _vm._s(
                                    record.project_id === "all"
                                      ? "Все проекты"
                                      : _vm.$AllProjects[record.project_id].name
                                  )
                                ),
                              ]
                            )
                          }
                        ),
                        0
                      ),
                    ],
                    1
                  ),
                ]),
              ])
            }),
            0
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { width: "50px" } }),
        _vm._v(" "),
        _c("th", [_vm._v("Менеджер")]),
        _vm._v(" "),
        _c("th", [_vm._v("Помощник")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }